var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPawnBlack2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 33,
    viewBox: "0 0 37 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1C10.29 1 8.5 2.79 8.5 5C8.5 5.89 8.79 6.71 9.28 7.38C7.33 8.5 6 10.59 6 13C6 15.03 6.94 16.84 8.41 18.03C5.41 19.09 1 23.58 1 31.5H24C24 23.58 19.59 19.09 16.59 18.03C18.06 16.84 19 15.03 19 13C19 10.59 17.67 8.5 15.72 7.38C16.21 6.71 16.5 5.89 16.5 5C16.5 2.79 14.71 1 12.5 1Z",
    fill: "black",
    stroke: "#AAAAAA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 1C22.29 1 20.5 2.79 20.5 5C20.5 5.89 20.79 6.71 21.28 7.38C19.33 8.5 18 10.59 18 13C18 15.03 18.94 16.84 20.41 18.03C17.41 19.09 13 23.58 13 31.5H36C36 23.58 31.59 19.09 28.59 18.03C30.06 16.84 31 15.03 31 13C31 10.59 29.67 8.5 27.72 7.38C28.21 6.71 28.5 5.89 28.5 5C28.5 2.79 26.71 1 24.5 1Z",
    fill: "black",
    stroke: "#AAAAAA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPawnBlack2);
export default __webpack_public_path__ + "static/media/Pawn Black 2.b0f1767bc0642f0fbb86ac9e69255a36.svg";
export { ForwardRef as ReactComponent };